<template>
  <div class="ai-visibility-competitor-brand-cell">
    <span class="ai-visibility-competitor-brand-cell__rank">{{ row.rank }}</span>
    <span class="ai-visibility-competitor-brand-cell__initial" :style="{backgroundColor: initialBGColor}">{{ row.initial }}</span>
    <div class="ai-visibility-competitor-brand-cell__copy">
      <div class="ai-visibility-competitor-brand-cell__title-line">
        <span class="ai-visibility-competitor-brand-cell__title">{{ row.brandName || row.domain }}</span>
        <panel-badge v-if="row.isTrackedDomain">You</panel-badge>
        <i
          v-if="row.isWatched"
          class="material-icons-outlined ai-visibility-competitor-brand-cell__pin"
          aria-label="Watched competitor"
        >
          push_pin
        </i>
      </div>
      <span class="ai-visibility-competitor-brand-cell__domain">{{ row.domain }}</span>
    </div>
  </div>
</template>

<script>
import PanelBadge from '../../../ui/display/PanelBadge.vue'
import {INITIAL_BACKGROUND_COLORS} from '../competitorMetrics'

export default {
  name: 'CompetitorBrandCell',
  components: {
    PanelBadge,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    initialBGColor() {
      const rank = Number(this.row.rank)
      return INITIAL_BACKGROUND_COLORS[rank % INITIAL_BACKGROUND_COLORS.length] || 'var(--v-mainColor-base)';
    },
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-competitor-brand-cell {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.ai-visibility-competitor-brand-cell__rank {
  flex: 0 0 24px;
  color: var(--v-mainColor3-base);
  font-size: 16px;
  font-weight: 400;
}

.ai-visibility-competitor-brand-cell__initial {
  display: inline-flex;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: var(--v-whiteColor-base);
  font-size: 12px;
  font-weight: 700;
}

.ai-visibility-competitor-brand-cell__copy {
  flex: 1 1 auto;
  min-width: 0;
}

.ai-visibility-competitor-brand-cell__title-line {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.ai-visibility-competitor-brand-cell__title {
  display: block;
  min-width: 0;
  overflow: hidden;
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ai-visibility-competitor-brand-cell__domain {
  display: block;
  overflow: hidden;
  color: var(--v-darkGrayColor-base);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ai-visibility-competitor-brand-cell__pin {
  flex: 0 0 auto;
  color: var(--v-profileAnchorColor-base);
  font-size: 16px;
}

.ai-visibility-competitor-brand-cell ::v-deep .ai-visibility-panel-badge {
  flex: 0 0 auto;
}
</style>
